/* eslint-disable class-methods-use-this */
class GotADiscount extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.autoOpenModal();
  }

  autoOpenModal() {
    if (window.location.hash == '#got-a-discount') {
      const button = document.querySelector('[data-modal="#Got-a-Discount-Input"]').querySelector('button');
      button.click();
    }
  }
}

if (!customElements.get('got-a-discount')) {
  window.customElements.define('got-a-discount', GotADiscount);
}

const revertUrl = () => {
  if (window.location.href.includes('#got-a-discount')) {
    window.history.pushState({}, '', window.location.origin);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('modalClosed', () => revertUrl());
});
